import { Modal } from '@bp/ui-components';
import { PersonParentForm } from 'components/Persons/forms/PersonParentForm';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type PersonParentModalProps = {
  childUuid: string;
  childName: string;
  isOpen: boolean;
  onClose: () => void;
};

export const PersonParentModal = ({ childUuid, childName, isOpen, onClose }: PersonParentModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={t('parents.editParentsOf', { name: childName })}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <PersonParentForm childUuid={childUuid} onLoad={(loading) => setLoading(loading)} onClose={() => onClose()} />
    </Modal>
  );
};
